export const COUNTRY_CODES = ['US', 'AU', 'BR', 'CA', 'FR', 'DE', 'MX', 'NL', 'ES', 'GB']

export const SCHEDULES_PATH = '/app/availability/schedules'
export const HOLIDAYS_PATH = '/app/availability/holidays'

export const ADVANCED_SETTINGS_PATH = '/app/availability/advanced_settings'
export const AVAILABILITY_EVENT_TYPES_TAG = { type: 'AVAILABILITY_EVENT_TYPES', id: 'LIST' }
export const AVAILABILITY_SCHEDULES_TAG = { type: 'AVAILABILITY_SCHEDULES', id: 'LIST' }
export const USER_HOLIDAY_SETS_TAG = { type: 'USER_HOLIDAY_SETS', id: 'LIST' }
export const USER_SETTINGS_TAG = { type: 'USER_SETTINGS', id: 'LIST' }

export const AVAILABILITY_INVALIDATION_TAGS = [AVAILABILITY_SCHEDULES_TAG, AVAILABILITY_EVENT_TYPES_TAG]
